// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AjaxLoaderController from "./ajax_loader_controller"
application.register("ajax-loader", AjaxLoaderController)

import ChangeCheatsheetStatusController from "./change_cheatsheet_status_controller"
application.register("change-cheatsheet-status", ChangeCheatsheetStatusController)

import CharsLeftController from "./chars_left_controller"
application.register("chars-left", CharsLeftController)

import CheatsheetFormController from "./cheatsheet_form_controller"
application.register("cheatsheet-form", CheatsheetFormController)

import ChoiceSelectController from "./choice_select_controller"
application.register("choice-select", ChoiceSelectController)

import CopySnippetController from "./copy_snippet_controller"
application.register("copy-snippet", CopySnippetController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FormController from "./form_controller"
application.register("form", FormController)

import IdeaFormController from "./idea_form_controller"
application.register("idea-form", IdeaFormController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MathFormulaController from "./math_formula_controller"
application.register("math-formula", MathFormulaController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PageController from "./page_controller"
application.register("page", PageController)

import PreviewContentController from "./preview_content_controller"
application.register("preview-content", PreviewContentController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SearchNavController from "./search_nav_controller"
application.register("search-nav", SearchNavController)

import SectionChartController from "./section_chart_controller"
application.register("section-chart", SectionChartController)

import SectionFormController from "./section_form_controller"
application.register("section-form", SectionFormController)

import SortableListController from "./sortable_list_controller"
application.register("sortable-list", SortableListController)

import TagsInputController from "./tags_input_controller"
application.register("tags-input", TagsInputController)

import TrackDownloadController from "./track_download_controller"
application.register("track-download", TrackDownloadController)

import TrackSearchController from "./track_search_controller"
application.register("track-search", TrackSearchController)

import TrackViewController from "./track_view_controller"
application.register("track-view", TrackViewController)
